import { PersonalInfoFormActionType } from "app/hooks";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { useInfoFormErrorsContext } from "pages/checkout/providers/InfoFormErrorsProvider";
import FormGroup from "shared/ui/FormGroup";
import Checkbox from "shared/ui/checkbox";
import Label from "shared/ui/label";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutInfoCheckboxesProps {
  className?: string;
}

const CheckoutInfoCheckboxes = ({ className }: CheckoutInfoCheckboxesProps) => {
  const { state, dispatch } = useCheckoutInfoContext();
  const { formErrors } = useInfoFormErrorsContext();

  const businessTypeGeneralRulesURL =
    state.type === "business"
      ? "https://gewoongers.nl/storage/pdf/metaalunievoorwaarden_2025_-_nederlands.pdf"
      : "https://gewoongers.nl/storage/pdf/gg_algemene_voorwaarden_thuiswinkel_2025.pdf";
  const toggleAgreedOnTerms = () => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_AGREED_ON_TERMS,
      payload: !state.agreedOnTerms,
    });
  };

  const toggleReceiveLetters = () => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_RECEIVE_LETTERS,
      payload: !state.receiveLetters,
    });
  };

  return (
    <div className={concatClassnames("", className)}>
      <FormGroup
        className="gg-col-span-12 gg-mb-3.5 gg-flex"
        errorMessage={formErrors["agreedOnTerms"]}
        displayError={state.isSubmitting}
      >
        <div className="gg-flex gg-flex-row gg-items-center gg-space-x-2">
          <Checkbox
            id="agreedOnTerms"
            checked={state.agreedOnTerms}
            className="gg-shrink-0"
            onChange={() => toggleAgreedOnTerms()}
            data-testid="form-terms-checkbox"
          />

          <Label htmlFor="agreedOnTerms" className="gg-grid">
            Ik heb mijn gegevens gecontroleerd en ga akkoord met de{" "}
            <a
              target="_blank"
              rel="noreferrer"
              className="gg-font-normal gg-underline hover:gg-text-slate-500"
              href={businessTypeGeneralRulesURL}
            >
              algemene voorwaarden
            </a>
          </Label>
        </div>
      </FormGroup>

      <FormGroup className="gg-col-span-12 gg-flex" isInline>
        <Checkbox
          id="agreed-on-promo"
          checked={state.receiveLetters}
          onChange={() => toggleReceiveLetters()}
        />

        <Label htmlFor="agreed-on-promo">
          Ik schrijf mij graag in voor de GewoonGers nieuwsbrief
        </Label>
      </FormGroup>
    </div>
  );
};
export default CheckoutInfoCheckboxes;
